export const META_TITLES = {
  features: {
    'en-US': 'Features',
    fr: 'Les fonctionnalités',
    'es-ES': 'Funcionalidades',
    it: 'Funzionalità',
  },
  contactUs: {
    'en-US': 'Contact us',
    fr: 'Nous contacter',
    'es-ES': 'Contacto',
    it: 'Contattaci',
  },
  about: {
    'en-US': 'About',
    fr: 'À propos de nous',
    'es-ES': 'Sobre',
    it: 'Chi siamo'
  },
  terms: {
    'en-US': 'Terms of Service',
    fr: 'Conditions générales',
    'es-ES': 'Términos y servicios',
    it: 'Termini e servizi'
  },
  privacyPolicy: {
    'en-US': 'Privacy Policy',
    fr: 'Politique de confidentialité',
    'es-ES': 'Política de privacidad',
    it: 'Informativa sulla privacy'
  },
  referralProgram: {
    'en-US': 'Referral Program',
    fr: 'Programme de parrainage',
    'es-ES': '',
    it: ''
  },
};

export const META_DESCRIPTIONS = {
  features: {
    'en-US':
      'Explore Hostaway’s powerful features, from Vacation Rental Software and Property Management tools to automation, channel management, and marketing solutions for short-term rental businesses',
    fr: "Découvrez toute la puissance des fonctionnalités d'Hostaway. Logiciel de gestion locative, outils de gestion de propriétés, automatisations, Channel Manager et solutions marketing : tout y est. Le choix numéro 1 pour la gestion locative saisonnière",
    'es-ES': 'Descubre todo el poder de las funcionalidades de Hostaway. Software de gestión de alquileres, herramientas para la gestión de propiedades, automatización, Channel Manager y soluciones de marketing: lo tiene todo. La opción número 1 para la gestión de alquileres vacacionales.',
    it: 'Scopri tutta la potenza delle funzionalità di Hostaway. Software di gestione degli affitti, strumenti per la gestione delle proprietà, automazione, Channel Manager e soluzioni di marketing: ha tutto. La scelta numero 1 per la gestione degli affitti vacanze.'
  },
  contactUs: {
    'en-US':
      'Contact Hostaway for sales, 24/7 support, partnerships, and careers. Reach our global team wherever you are.',
    fr: "Contactez Hostaway pour une démo, un support 24/7, nos partenariats ou nos offres d'emploi. Notre équipe internationale est là pour vous aider, où que vous soyez.",
    'es-ES':
      'Contacta con Hostaway para ventas, soporte 24/7, partners y empleo. Comunícate con nuestro equipo global estés donde estés.',
    it: 'Contatta Hostaway per vendite, assistenza 24/7, partnership e opportunità di lavoro. Il nostro team globale è a tua disposizione ovunque tu sia.',
  },
  about: {
    'en-US':
      'Discover Hostaway, the leading Vacation Rental Software for property managers. Streamline short-term rental management with powerful Airbnb and Property Management Software solutions.',
    fr: 'Découvrez Hostaway, le logiciel de gestion locative par excellence pour les gestionnaires de propriétés. Simplifiez la gestion de vos locations saisonnières grâce à des solutions puissantes de gestion locative et Airbnb.',
    'es-ES': 'Descubre Hostaway, el software de alquiler vacacional líder para gestores de propiedades. Optimiza la gestión de alquileres a corto plazo con potentes soluciones de software para Airbnb y gestión de propiedades.',
    it: 'Scopri Hostaway, il software per affitti vacanze leader per i gestori di proprietà. Ottimizza la gestione degli affitti a breve termine con potenti soluzioni software per Airbnb e gestione delle proprietà.'
  },
  terms: {
    'en-US':
      'Review Hostaway’s Terms of Service for using our Vacation Rental Software. Understand the guidelines and agreements for our property management solutions',
    fr: 'Révisez les conditions générales et les conditions d’utilisation de Hostaway pour utiliser notre logiciel de location de vacances. Comprenez les règles et les accords pour nos solutions de gestion de propriété',
    'es-ES': '',
    it: ''
  },
  privacyPolicy: {
    'en-US':
      'Learn how Hostaway protects your personal data with our comprehensive Privacy Policy. We ensure your information is safe while using our Vacation Rental Software solutions',
    fr: 'Découvrez comment Hostaway protège vos données personnelles avec notre politique de confidentialité complète. Nous nous assurons que vos informations sont sûres lorsque vous utilisez nos solutions de logiciel de location de vacances',
    'es-ES': '',
    it: ''
  },
  referralProgram: {
    'en-US':
      'Sign up for the Hostaway Referral Partner Program. If you work with property managers and vacation rental owners as a trainer, coach, mentor, influencer or consultant, you’ve come to the right place! Your partners are hustling entrepreneurs and we’d like to offer them the best of the best when it’s time to choose a PMS and Channel Manager.',
    fr: 'Inscrivez-vous au Programme de Parrainage Hostaway. Si vous collaborez avec des gestionnaires de propriétés et des propriétaires de locations saisonnières en tant que formateur, coach, mentor, influenceur ou consultant, vous êtes au bon endroit ! Vos partenaires sont des entrepreneurs engagés, et nous souhaitons leur fournir le meilleur PMS / Channel Manager.',
    'es-ES': '',
    it: ''
  },
};

export function generateLandingPagesMetadata({ logo, screen, language }) {
  const metaData = {
    'en-US': [
      {
        name: 'og:url',
        content: 'https://www.hostaway.com/',
      },
      {
        name: 'description',
        content:
          'Manage your short-term rental properties across multiple channels like Airbnb, Vrbo and Booking.com with Hostaway&#39;s #1 vacation rental software.',
      },
      {
        name: 'keywords',
        content:
          'Vacation rental software, Channel management software, Vacation rental management, Channel manager, Short-term rental management, Property management software, Airbnb channel manager, Booking.com channel manager, Homeaway channel manager, Expedia channel manager, TripAdvisor channel manager, Unified Guest message inbox',
      },
      {
        property: 'og:locale',
        content: 'en_US',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:title',
        content: 'Manage your vacation rental properties like a Pro!',
      },
      {
        property: 'og:description',
        content:
          'Manage unlimited vacation rental channel reservations from check-in to check-out by one platform.',
      },
      {
        property: 'og:site_name',
        content: 'Hostaway',
      },
      {
        property: 'fb:app_id',
        content: '966242223397117',
      },
      {
        property: 'og:image',
        content: `https://www.hostaway.com${logo}`,
      },
      {
        property: 'og:image:secure_url',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:card',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:description',
        content:
          'With Hostaway you successfully manage unlimited vacation rental channel reservations from check-in to check-out by one platform.',
      },
      {
        property: 'twitter:title',
        content: 'Manage your vacation rental properties like a Pro',
      },
      {
        property: 'twitter:site',
        content: '@Hostaway',
      },
    ],
    fr: [
      {
        name: 'og:url',
        content: 'https://www.hostaway.com/fr',
      },
      {
        name: 'description',
        content:
          'Gérez vos propriétés de location à court terme sur plusieurs canaux comme Airbnb, Vrbo et Booking.com avec le logiciel de location de vacances n°1 de Hostaway.',
      },
      {
        name: 'keywords',
        content:
          'Logiciel de location de vacances, Logiciel de gestion de canaux, Gestion de location de vacances, Gestionnaire de canaux, Gestion de location à court terme, Logiciel de gestion de propriété, Gestionnaire de canaux Airbnb, Gestionnaire de canaux Booking.com, Gestionnaire de canaux Homeaway, Gestionnaire de canaux Expedia, Gestionnaire de canaux TripAdvisor, Boîte de réception de messages invités unifiée',
      },
      {
        property: 'og:locale',
        content: 'fr_FR',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:title',
        content: 'Gérez vos propriétés de location de vacances comme un pro!',
      },
      {
        property: 'og:description',
        content:
          'Gérez des réservations de canaux de location de vacances illimitées de l&#39;enregistrement au départ par une seule plateforme.',
      },
      {
        property: 'og:site_name',
        content: 'Hostaway',
      },
      {
        property: 'fb:app_id',
        content: '966242223397117',
      },
      {
        property: 'og:image',
        content: `https://www.hostaway.com${logo}`,
      },
      {
        property: 'og:image:secure_url',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:card',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:description',
        content:
          'Avec Hostaway, vous gérez avec succès des réservations de canaux de location de vacances illimitées de l&#39;enregistrement au départ par une seule plateforme.',
      },
      {
        property: 'twitter:title',
        content: 'Gérez vos propriétés de location de vacances comme un pro',
      },
      {
        property: 'twitter:site',
        content: '@Hostaway',
      },
    ],
    'es-ES': [
      {
        name: 'og:url',
        content: 'https://www.hostaway.com/es-ES',
      },
      {
        name: 'description',
        content:
          'Ahorra tiempo y aumenta tus reservas con Hostaway, el software todo en uno para alquileres vacacionales. Automatiza la gestión de propiedades y sincroniza con Airbnb, Vrbo y más.',
      },
      {
        name: 'keywords',
        content:
          'Software de alquiler vacacional, Software de alquiler a corto plazo, Software de gestión de propiedades, Channel manager, Página principal de gestión de Airbnb',
      },
      {
        property: 'og:locale',
        content: 'es_ES',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:title',
        content: '¡Gestiona tus propiedades de alquiler vacacional como un Pro!',
      },
      {
        property: 'og:description',
        content: 'Gestiona reservas ilimitadas de canales de alquiler vacacional desde el check-in hasta el check-out en una sola plataforma.',
      },
      {
        property: 'og:site_name',
        content: 'Hostaway',
      },
      {
        property: 'fb:app_id',
        content: '966242223397117',
      },
      {
        property: 'og:image',
        content: `https://www.hostaway.com${logo}`,
      },
      {
        property: 'og:image:secure_url',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:card',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:description',
        content: 'Con Hostaway, puedes gestionar a la perfección reservas ilimitadas de canales de alquiler vacacional desde el check-in hasta el check-out en una sola plataforma.',
      },
      {
        property: 'twitter:title',
        content: 'Gestiona tus propiedades de alquiler vacacional como un Pro',
      },
      {
        property: 'twitter:site',
        content: '@Hostaway',
      },
    ],
    'it': [
      {
        name: 'og:url',
        content: 'https://www.hostaway.com/it',
      },
      {
        name: 'description',
        content: 'Risparmia tempo e aumenta le tue prenotazioni con Hostaway, il software tutto in uno per gli affitti brevi. Automatizza la gestione delle proprietà e sincronizza con Airbnb, Vrbo e altro.',
      },
      {
        name: 'keywords',
        content: 'Software per affitti vacanze, Software per affitti a breve termine, Software di gestione delle proprietà, Channel manager',
      },
      {
        property: 'og:locale',
        content: 'it',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:title',
        content: 'Gestisci i tuoi affitti per le vacanze come un professionista!',
      },
      {
        property: 'og:description',
        content: 'Gestisci prenotazioni illimitate sui canali di affitti per le vacanze, dal check-in al check-out, tramite un\'unica piattaforma.',
      },
      {
        property: 'og:site_name',
        content: 'Hostaway',
      },
      {
        property: 'fb:app_id',
        content: '966242223397117',
      },
      {
        property: 'og:image',
        content: `https://www.hostaway.com${logo}`,
      },
      {
        property: 'og:image:secure_url',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:card',
        content: `https://www.hostaway.com${screen}`,
      },
      {
        property: 'twitter:description',
        content: 'Con Hostaway, gestisci al meglio prenotazioni illimitate sui canali di affitti per le vacanze, dal check-in al check-out, tramite un\'unica piattaforma.',
      },
      {
        property: 'twitter:title',
        content: 'Gestisci i tuoi affitti per le vacanze come un professionista',
      },
      {
        property: 'twitter:site',
        content: '@Hostaway',
      },
    ],
  };

  return metaData[language];
}
